<div class="chat-list-window-inner">
  <div class="d-flex align-items-center mb-2 search-banner px-1 mt-2">
    <!-- Logo (Desktop) -->
    <div class="sidebar-logo d-none d-md-flex align-items-center mr-2">
      <a routerLink="/home" class="logo-link d-flex align-items-center" title="Go to home">
        <img src="assets/login/header-logo.png" alt="Logo" class="sidebar-logo-img">
      </a>
    </div>

    <!-- Search Bar -->
    <div class="search-container position-relative flex-grow-1 d-flex align-items-center">
      <div class="position-relative flex-grow-1">
        <input type="text" class="form-control" placeholder="Search..." aria-label="Search"
          aria-describedby="search-addon" [(ngModel)]="searchQuery" (input)="onSearchInput()" />
        <svg class="search-icon" width="19" height="19" viewBox="0 0 19 19" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 18L13.8033 13.8033M16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C12.6421 16 16 12.6421 16 8.5Z"
            stroke="#A19791" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      @if (searchQuery) {
      <svg class="clear-icon" (click)="onClearSearch()" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
        viewBox="0 0 24 24" style="flex-shrink: 0;">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"
          d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
      </svg>
      }
      <div class="tooltip-wrapper">
        <button class="btn-advanced-search ml-1" (click)="openAdvancedSearch.emit()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <!-- Main Search Circle -->
            <circle cx="11" cy="11" r="8"></circle>
            <!-- Search Handle -->
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            <!-- Advanced Filter Indicators -->
            <line x1="8" y1="9" x2="14" y2="9"></line>
            <line x1="8" y1="13" x2="12" y2="13"></line>
          </svg>
        </button>
        <span class="custom-tooltip">Advanced Search</span>
      </div>
    </div>

    <!-- 3-Dots Menu -->
    <div class="side-menu position-relative" #dropdownContainer>
      <button class="btn btn-icon" (click)="toggleMenuDropdown()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-more-vertical">
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="12" cy="5" r="1"></circle>
          <circle cx="12" cy="19" r="1"></circle>
        </svg>
      </button>
      @if (showMenuDropdown) {
      <div class="dropdown-menu show" style="right: 0; left: auto; top: 100%">
        <button class="dropdown-item d-flex align-items-center" (click)="onCreateGroup()">
          <svg class="mr-1" style="margin-top: 2px" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
            viewBox="0 0 24 24">
            <path fill="#000" d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z" />
          </svg>
          New group
        </button>
        <button class="dropdown-item d-flex align-items-center" (click)="onOpenStarred()">
          <svg class="mr-1" style="color: #ffbc00" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
            viewBox="0 0 24 24">
            <path fill="currentColor"
              d="m12 17.27l4.15 2.51l-1.1-4.73L18.5 11.7l-4.77-.41L12 7l-1.73 4.29l-4.77.41l3.45 3.37l-1.1 4.73z" />
          </svg>
          Starred
        </button>
      </div>
      }
    </div>
  </div>

  <!-- Chat Filter Tabs -->
  <div class="chat-filter-tabs mb-2">
    <div class="filter-tab-item" [class.active]="activeTab === 'all'" (click)="onTabSwitch('all')">
      <button class="filter-tab" [class.active]="activeTab === 'all'">
        <span class="tab-label">All</span>
      </button>
      @if (unreadCounts.all > 0) {
      <span class="unread-badge">{{ unreadCounts.all }}</span>
      }
    </div>
    <div class="filter-tab-item" [class.active]="activeTab === 'single'" (click)="onTabSwitch('single')">
      <button class="filter-tab" [class.active]="activeTab === 'single'">
        <span class="tab-label">Single</span>
      </button>
      @if (unreadCounts.single > 0) {
      <span class="unread-badge">{{ unreadCounts.single }}</span>
      }
    </div>
    <div class="filter-tab-item" [class.active]="activeTab === 'group'" (click)="onTabSwitch('group')">
      <button class="filter-tab" [class.active]="activeTab === 'group'">
        <span class="tab-label">Group</span>
      </button>
      @if (unreadCounts.group > 0) {
      <span class="unread-badge">{{ unreadCounts.group }}</span>
      }
    </div>
    <div class="filter-tab-item" [class.active]="activeTab === 'unread'" (click)="onTabSwitch('unread')">
      <button class="filter-tab" [class.active]="activeTab === 'unread'">
        <span class="tab-label">Unread</span>
      </button>
      @if (unreadCounts.unread > 0) {
      <span class="unread-badge">{{ unreadCounts.unread }}</span>
      }
    </div>
    <!-- <button class="filter-tab" [class.active]="activeTab === 'starred'" (click)="onTabSwitch('starred')">
      Starred
    </button> -->
  </div>

  <div class="user-list-container">
    @if (chatListLoading) {
    @for (_ of skeletonPlaceholders; track $index) {
    <div class="user-list-banner d-flex mt-3">
      <div class="skeleton-avatar shimmer-block"></div>
      <div class="w-100 mx-3">
        <div class="skeleton-line shimmer-block name"></div>
        <div class="skeleton-line shimmer-block message"></div>
      </div>
      <div class="skeleton-time shimmer-block"></div>
    </div>
    }
    } @else if (isSearchActive) {
    @if (matchedChats.length > 0) {
    <h6 class="search-heading">Chats</h6>
    @for (chat of matchedChats; track trackByChat($index, chat)) {
    <div style="width: 100%" (click)="onChatClick(chat)">
      <div class="user-list-banner d-flex mt-3" [class.selected-chat]="
                chat.chatType === 'single'
                  ? isSingleChatSelected(chat.userId)
                  : isGroupChatSelected(chat.channelId)
              ">
        <div style="width: 44px; flex-shrink: 0;">
          <img [src]="getChatImage(chat)" (error)="handleProfileImageError($event, isGroupChat(chat))" alt="user"
            class="user-profile-img" />
        </div>
        <div class="user-item-main ml-2">
          <div class="user-list-info d-flex align-items-center justify-content-between w-100">
            <p class="user-list-name">
              <span class="chat-name-text">{{ chat.chatType === "group" ? chat.groupName : chat.displayName ||
                chat.userName }}</span>
            </p>
            <span class="user-list-time">{{ chat.lastMessageTimeAgo }}</span>
          </div>
          <div class="timeCount d-flex align-items-center justify-content-between">

            <p class="user-recent-msg mb-0">
              @if (getTypingTextForChat(chat)) {
              <span class="typing-indicator-text-sidebar">{{ getTypingTextForChat(chat) }}</span>
              } @else if (hasDraft(chat)) {
              <span class="draft-indicator-container">
                <span class="draft-prefix">Draft : </span>
                <span class="draft-text" [innerHTML]="getDraftText(chat) | highlightText: searchQuery"></span>
              </span>
              } @else if (chat.lastMessage?.message) {
              @if (chat.chatType === "group") {
              @if (chat.lastMessage.sender_id === userId) {
              @if (chat.lastMessage.pending) {
              <!-- Clock: queued in outbox, waiting for connection -->
              <svg xmlns="http://www.w3.org/2000/svg" aria-label="Waiting to send"
                style="width: 14px; height: 14px; min-width: 14px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="6.25" fill="none" stroke="#6c6968" stroke-width="1.5" />
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M8 4.75V8l2.25 1.5" />
              </svg>
              } @else if (isMessageSeen(chat.lastMessage)) {
              <!-- Blue Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 2px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#1fa5f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              } @else {
              <!-- Grey Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 2px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              }
              }
              @if (!isSystemMessage(chat.lastMessage)) {
              <span class="recent-sender">{{ chat.lastMessage.sender_id === userId ? "You" :
                (userNameMapping[chat.lastMessage.sender_id] || chat.lastMessage.name || "")
                }}</span>
              }
              @if (isVoiceMessage(chat.lastMessage)) {
              <span class="recent-message-text d-inline-flex align-items-center">
                {{ isSystemMessage(chat.lastMessage) ? "" : ": " }}
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="mx-1 text-muted">
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                  <line x1="12" y1="19" x2="12" y2="23"></line>
                  <line x1="8" y1="23" x2="16" y2="23"></line>
                </svg>
                Voice message {{ getVoiceDuration(chat.lastMessage) }}
              </span>
              } @else {
              <span class="recent-message-text"
                [innerHTML]="((isSystemMessage(chat.lastMessage) ? '' : ': ') + getDisplayLastMessageText(chat.lastMessage)) | highlightText: searchQuery"></span>
              }
              } @else {
              @if (chat.lastMessage.sender_id === userId) {
              @if (chat.lastMessage.pending) {
              <!-- Clock: queued in outbox, waiting for connection -->
              <svg xmlns="http://www.w3.org/2000/svg" aria-label="Waiting to send"
                style="width: 14px; height: 14px; min-width: 14px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="6.25" fill="none" stroke="#6c6968" stroke-width="1.5" />
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M8 4.75V8l2.25 1.5" />
              </svg>
              } @else if (isMessageSeen(chat.lastMessage)) {
              <!-- Blue Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#1fa5f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              } @else {
              <!-- Grey Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              }
              }
              @if (isVoiceMessage(chat.lastMessage)) {
              <span class="recent-message-text d-inline-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="mr-1 text-muted">
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                  <line x1="12" y1="19" x2="12" y2="23"></line>
                  <line x1="8" y1="23" x2="16" y2="23"></line>
                </svg>
                Voice message {{ getVoiceDuration(chat.lastMessage) }}
              </span>
              } @else {
              <span class="recent-message-text"
                [innerHTML]="getDisplayLastMessageText(chat.lastMessage) | highlightText: searchQuery"></span>
              }
              }
              } @else {
              <span>No recent message</span>
              }
            </p>
            @if (chat.unreadCount && +chat.unreadCount > 0) {
            <div class="chat-status-right">
              <p class="unread-msg-count mb-0">
                <span class="unread-msg">{{ chat.unreadCount }}</span>
              </p>
            </div>
            } @else if (isChatPinned(chat)) {
            <div class="chat-status-right">
              <span class="chat-pinned-icon" title="Pinned chat">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                  <path
                    d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z" />
                </svg>
              </span>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }
    }
    <!-- Message search listing -->
    @if (matchedMessages.length > 0) {
    <h6 class="search-heading">Messages</h6>
    @for (chat of matchedMessages; track chat.channelId || chat.userId || $index) {
    <div style="width: 100%" (click)="onChatClick(chat)">
      <div class="search-result-item" [class.selected-chat]="
                chat.chatType === 'single'
                  ? isSingleChatSelected(chat.otherUserId || chat.userId)
                  : isGroupChatSelected(chat.channelId)
              ">
        <div class="search-result-header">
          <span class="search-result-name">{{ chat.chatType === "group" ? chat.groupName : chat.displayName ||
            chat.userName }}</span>
          <span class="search-result-time">{{ chat.lastMessageTimeAgo }}</span>
        </div>

        <div class="search-result-body">
          <div class="message-text-container"
            [class.message-with-thumbnail]="chat.lastMessage.meta?.image && !chat.lastMessage.meta?.title">
            <div class="search-result-message">
              @if (chat.chatType === "group" && !isSystemMessage(chat.lastMessage)) {
              <span class="recent-sender">{{ chat.lastMessage.sender_id === userId ? "You" :
                (userNameMapping[chat.lastMessage.sender_id] || chat.lastMessage.name || "")
                }}: </span>
              }
              <span class="recent-message-text"
                [innerHTML]="getDisplayLastMessageText(chat.lastMessage) | highlightText: searchQuery"></span>
            </div>

            @if (chat.lastMessage.meta?.image && !chat.lastMessage.meta?.title) {
            <img [src]="chat.lastMessage.meta.image" class="message-thumbnail" />
            }
          </div>

          <!-- Link Preview Card -->
          @if (chat.lastMessage.meta?.title || chat.lastMessage.meta?.description) {
          <div class="link-preview-card">
            @if (chat.lastMessage.meta?.image) {
            <img [src]="chat.lastMessage.meta.image" class="link-preview-image"
              (error)="handleLinkImageError($event)" />
            }
            <div class="link-preview-content">
              @if (chat.lastMessage.meta?.title) {
              <p class="link-preview-title" [innerHTML]="chat.lastMessage.meta.title | highlightText: searchQuery"></p>
              }
              @if (chat.lastMessage.meta?.description) {
              <p class="link-preview-desc" [innerHTML]="chat.lastMessage.meta.description | highlightText: searchQuery">
              </p>
              }
              <div class="d-flex align-items-center mt-1">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  class="mr-1">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
                <span class="link-preview-site">{{ chat.lastMessage.message }}</span>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }
    }
    @if (matchedChats.length === 0 && matchedMessages.length === 0 && !isSearching) {
    <div class="text-center mt-3">
      <p style="color: #888">No results found</p>
      <p style="color: #888">Try a new search</p>
    </div>
    }
    } @else {
    <!-- Default View (No Search) -->
    @if (activeTab === 'starred') {
    @for (message of starredMessages; track (message._id || message.id || i); let i = $index) {
    <div style="width: 100%" (click)="starredMessageSelected.emit(message)">
      <div class="user-list-banner d-flex mt-3">
        <div style="width: 50px">
          <img
            [src]="profileImageMapping[message.message?.sender_id] || profileImageMapping[message.sender_id] || 'assets/user-icon.png'"
            (error)="handleProfileImageError($event, false)" alt="user" class="user-profile-img" />
        </div>
        <div class=" w-100 ml-2 mr-1">
          <div class="user-list-info d-flex align-items-center justify-content-between w-100">
            <p class="user-list-name">
              {{ (message.message?.name || userNameMapping[message.message?.sender_id]) || message.starredByName ||
              'User' }}
            </p>
            <span class="user-list-time">{{ message.createdAt | date:'MMM d' }}</span>
          </div>
          <div class="timeCount d-flex flex-column align-items-start mt-1">
            @if (getReplyThumbnail(message.message || message)) {
            <div class="starred-media-preview mb-2">
              @if (getReplyMediaType(message.message || message) === 'Photo' || getReplyMediaType(message.message ||
              message) === 'GIF') {
              <img [src]="getReplyThumbnail(message.message || message)" (error)="handleMediaError($event, message)"
                class="starred-thumb" />
              } @else if (getReplyMediaType(message.message || message) === 'Video') {
              <div class="video-preview-sidebar">
                <img [src]="getReplyThumbnail(message.message || message)" (error)="handleMediaError($event, message)"
                  class="starred-thumb" />
                <div class="play-overlay-sidebar">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 16 16">
                    <path
                      d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                  </svg>
                </div>
              </div>
              } @else {
              <div class="starred-doc-card d-flex align-items-center">
                <img [src]="getReplyThumbnail(message.message || message)" (error)="handleMediaError($event, message)"
                  width="24" height="24" class="mr-2" />
                <span class="doc-name-sidebar text-truncate">{{ message.message?.message || message.msg || 'Attached
                  File' }}</span>
              </div>
              }
            </div>
            }

            <p class="user-recent-msg mb-0 text-truncate" style="max-width: 200px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" class="mr-1">
                <path fill="#ffbc00"
                  d="m12 17.27l4.15 2.51l-1.1-4.73L18.5 11.7l-4.77-.41L12 7l-1.73 4.29l-4.77.41l3.45 3.37l-1.1 4.73z" />
              </svg>
              <span
                [innerHTML]="((getReplyThumbnail(message.message || message) && getReplyMediaType(message.message || message) !== 'Document') ? (message.message?.meta?.caption || message.message?.message || message.msg || '') : (message.message?.message || message.msg || 'No content')) | highlightText: searchQuery"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    }
    } @else {
    @for (chat of filteredChatsByTab; track trackByChat($index, chat)) {
    <div class="chat-row" [class.menu-open]="chatMenuChannelId === chat.channelId" (click)="onChatRowClick(chat)"
      (contextmenu)="openChatMenu(chat, $event)" (touchstart)="onChatTouchStart(chat)" (touchend)="cancelLongPress()"
      (touchmove)="cancelLongPress()" (touchcancel)="cancelLongPress()">
      <div class="user-list-banner d-flex" [class.selected-chat]="
                chat.chatType === 'single'
                  ? isSingleChatSelected(chat.userId)
                  : isGroupChatSelected(chat.channelId)
              ">
        <div style="width: 44px; flex-shrink: 0;">
          <img [src]="getChatImage(chat)" (error)="handleProfileImageError($event, isGroupChat(chat))" alt="user"
            class="user-profile-img" />
        </div>
        <div class="user-item-main ml-2">
          <div class="user-list-info d-flex align-items-center justify-content-between w-100">
            <p class="user-list-name">
              <span class="chat-name-text">{{ chat.chatType === "group" ? chat.groupName : chat.displayName ||
                chat.userName }}</span>
            </p>
            <span class="user-list-time">{{ chat.lastMessageTimeAgo }}</span>
          </div>
          <div class="timeCount d-flex align-items-center justify-content-between">

            <p class="user-recent-msg mb-0">
              @if (getTypingTextForChat(chat)) {
              <span class="typing-indicator-text-sidebar">{{ getTypingTextForChat(chat) }}</span>
              } @else if (hasDraft(chat)) {
              <span class="draft-indicator-container">
                <span class="draft-prefix">Draft : </span>
                <span class="draft-text" [innerHTML]="getDraftText(chat) | highlightText: searchQuery"></span>
              </span>
              } @else if (chat.lastMessage?.message) {
              @if (chat.chatType === "group") {
              @if (chat.lastMessage.sender_id === userId) {
              @if (chat.lastMessage.pending) {
              <!-- Clock: queued in outbox, waiting for connection -->
              <svg xmlns="http://www.w3.org/2000/svg" aria-label="Waiting to send"
                style="width: 14px; height: 14px; min-width: 14px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="6.25" fill="none" stroke="#6c6968" stroke-width="1.5" />
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M8 4.75V8l2.25 1.5" />
              </svg>
              } @else if (isMessageSeen(chat.lastMessage)) {
              <!-- Blue Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 2px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#1fa5f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              } @else {
              <!-- Grey Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 2px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              }
              }
              @if (!isSystemMessage(chat.lastMessage)) {
              <span class="recent-sender">{{ chat.lastMessage.sender_id === userId ? "You" :
                (userNameMapping[chat.lastMessage.sender_id] || chat.lastMessage.name || "")
                }}</span>
              }
              @if (isVoiceMessage(chat.lastMessage)) {
              <span class="recent-message-text d-inline-flex align-items-center">
                {{ isSystemMessage(chat.lastMessage) ? "" : ": " }}
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="mx-1 text-muted">
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                  <line x1="12" y1="19" x2="12" y2="23"></line>
                  <line x1="8" y1="23" x2="16" y2="23"></line>
                </svg>
                Voice message {{ getVoiceDuration(chat.lastMessage) }}
              </span>
              } @else {
              <span class="recent-message-text"
                [innerHTML]="((isSystemMessage(chat.lastMessage) ? '' : ': ') + getDisplayLastMessageText(chat.lastMessage)) | highlightText: searchQuery"></span>
              }
              } @else {
              @if (chat.lastMessage.sender_id === userId) {
              @if (chat.lastMessage.pending) {
              <!-- Clock: queued in outbox, waiting for connection -->
              <svg xmlns="http://www.w3.org/2000/svg" aria-label="Waiting to send"
                style="width: 14px; height: 14px; min-width: 14px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="6.25" fill="none" stroke="#6c6968" stroke-width="1.5" />
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M8 4.75V8l2.25 1.5" />
              </svg>
              } @else if (isMessageSeen(chat.lastMessage)) {
              <!-- Blue Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#1fa5f2" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              } @else {
              <!-- Grey Double Tick -->
              <svg xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px; min-width: 16px; flex-shrink: 0; margin-right: 4px;"
                viewBox="0 0 16 16">
                <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m1.75 9.75 2.5 2.5m3.5-4 2.5-2.5m-4.5 4 2.5 2.5 6-6.5" />
              </svg>
              }
              }
              @if (isVoiceMessage(chat.lastMessage)) {
              <span class="recent-message-text d-inline-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="mr-1 text-muted">
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                  <line x1="12" y1="19" x2="12" y2="23"></line>
                  <line x1="8" y1="23" x2="16" y2="23"></line>
                </svg>
                Voice message {{ getVoiceDuration(chat.lastMessage) }}
              </span>
              } @else {
              <span class="recent-message-text"
                [innerHTML]="getDisplayLastMessageText(chat.lastMessage) | highlightText: searchQuery"></span>
              }
              }
              } @else {
              <span>No recent message</span>
              }
            </p>
            @if (chat.unreadCount && +chat.unreadCount > 0) {
            <div class="chat-status-right">
              <p class="unread-msg-count mb-0">
                <span class="unread-msg">{{ chat.unreadCount }}</span>
              </p>
            </div>
            } @else if (isChatPinned(chat)) {
            <div class="chat-status-right">
              <span class="chat-pinned-icon" title="Pinned chat">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                  <path
                    d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z" />
                </svg>
              </span>
            </div>
            }
          </div>
        </div>
      </div>
      @if (chatMenuChannelId === chat.channelId) {
      <div class="chat-options-menu" (click)="$event.stopPropagation()">
        <button type="button" class="chat-options-item" (click)="onTogglePin(chat, $event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="17" x2="12" y2="22"></line>
            <path
              d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z">
            </path>
            @if (isChatPinned(chat)) {
            <line x1="2" y1="2" x2="22" y2="22"></line>
            }
          </svg>
          {{ isChatPinned(chat) ? 'Unpin from Top' : 'Pin to Top' }}
        </button>
      </div>
      }
    </div>
    }
    }
    }
    <!-- Empty state when no chats match the active tab -->
    @if (!chatListLoading && !isSearchActive && filteredChatsByTab.length === 0) {
    <div class="tab-empty-state">
      @if (activeTab === "unread") {
      <div class="tab-empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" fill="none">
          <circle cx="32" cy="32" r="30" fill="#EEF1FB" />
          <path d="M20 24h24v18a2 2 0 01-2 2H22a2 2 0 01-2-2V24z" fill="#c5d0f0" />
          <path d="M20 24l12 9 12-9" stroke="#7d96d7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="46" cy="20" r="6" fill="#82cf9c" />
          <path d="M43 20l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <p class="tab-empty-title">You're all caught up!</p>
      <p class="tab-empty-sub">No unread messages right now.</p>
      } @else {
      <div class="tab-empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" fill="none">
          <circle cx="32" cy="32" r="30" fill="#EEF1FB" />
          <path d="M18 38c0-9.941 6.268-18 14-18s14 8.059 14 18v3H18v-3z" fill="#c5d0f0" />
          <ellipse cx="32" cy="41" rx="14" ry="3" fill="#b0bedd" opacity=".4" />
          <circle cx="32" cy="25" r="5" fill="#7d96d7" />
        </svg>
      </div>
      <p class="tab-empty-title">No chats here</p>
      <p class="tab-empty-sub">
        Start a conversation by tapping<br />the compose button above.
      </p>
      }
    </div>
    }
  </div>
</div>